var map = {
	"./Data LocalityandStateful.png": 7431,
	"./DatabaseCostOptimization.png": 4794,
	"./DeepEngineeringExpertise.png": 3057,
	"./DistributedControlPlane.png": 2165,
	"./DomainExpertise.png": 1528,
	"./GitOps.png": 6829,
	"./GlobalLoadBalancing.png": 9963,
	"./Serverless&Event-Driven.png": 9982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7150;